/**
 * A generic dropdown component.  It takes the children of the component
 * and hosts it in the component.  When the component is selected, it
 * drops-down the contentComponent and applies the contentProps.
 */
import React, { useEffect, useRef, useState } from 'react';
import { useMultiSelect } from '../MultiSelect/hooks/UseMultiSelect';
import { useDidUpdateEffect } from '../MultiSelect/hooks/UseDidUpdateEfect';
import { KEY } from '../MultiSelect/lib/constants';
import { useKey } from '../MultiSelect/hooks/UseKey';
import { ItemSelect } from './ItemSelect';
var InlineSelect = function () {
    var _a = useMultiSelect(), t = _a.t, onMenuToggle = _a.onMenuToggle, shouldToggleOnHover = _a.shouldToggleOnHover, disabled = _a.disabled, onChange = _a.onChange, labelledBy = _a.labelledBy, value = _a.value, isOpen = _a.isOpen, defaultIsOpen = _a.defaultIsOpen, options = _a.options;
    var _b = useState(true), isInternalExpand = _b[0], setIsInternalExpand = _b[1];
    var _c = useState(defaultIsOpen), expanded = _c[0], setExpanded = _c[1];
    var _d = useState(false), hasFocus = _d[0], setHasFocus = _d[1];
    var wrapper = useRef();
    useDidUpdateEffect(function () {
        if (onMenuToggle) {
            onMenuToggle(expanded);
        }
    }, [expanded]);
    useEffect(function () {
        if (defaultIsOpen === undefined && typeof isOpen === 'boolean') {
            setIsInternalExpand(false);
            setExpanded(isOpen);
        }
    }, [isOpen]);
    var handleKeyDown = function (e) {
        var _a;
        // allows space and enter when focused on input/button
        if (['text', 'button'].includes(e.target.type) &&
            [KEY.SPACE, KEY.ENTER].includes(e.code)) {
            return;
        }
        if (isInternalExpand) {
            if (e.code === KEY.ESCAPE) {
                setExpanded(false);
                (_a = wrapper === null || wrapper === void 0 ? void 0 : wrapper.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
            else {
                setExpanded(true);
            }
        }
        e.preventDefault();
    };
    useKey([KEY.ENTER, KEY.ARROW_DOWN, KEY.SPACE, KEY.ESCAPE], handleKeyDown, {
        target: wrapper,
    });
    var handleHover = function (iexpanded) {
        if (isInternalExpand && shouldToggleOnHover) {
            setExpanded(iexpanded);
        }
    };
    var handleFocus = function () { return !hasFocus && setHasFocus(true); };
    var handleBlur = function (e) {
        if (!e.currentTarget.contains(e.relatedTarget) && isInternalExpand) {
            setHasFocus(false);
            setExpanded(false);
        }
    };
    var handleMouseEnter = function () { return handleHover(true); };
    var handleMouseLeave = function () { return handleHover(false); };
    return (React.createElement("div", { tabIndex: 0, className: "dropdown-container", "aria-labelledby": labelledBy, "aria-expanded": expanded, "aria-readonly": true, "aria-disabled": disabled, ref: wrapper, onFocus: handleFocus, onBlur: handleBlur, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave },
        React.createElement("div", { style: {
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center'
            } }, options.map(function (option) {
            var optionDisabled = option.disabled;
            return (React.createElement(ItemSelect, { key: option.label, onClick: function () {
                    if (optionDisabled) {
                        return;
                    }
                    onChange(option);
                }, disabled: optionDisabled, selected: value.find(function (v) { return v.value === option.value; }) }, option.label));
        }))));
};
export default InlineSelect;



//////////////////
// WEBPACK FOOTER
// ./src/components/InlineSelect/InlineSelect.tsx
// module id = 1203
// module chunks = 0